export const disarmRefTimer = (
  timer: React.MutableRefObject<NodeJS.Timeout | null>
) => {
  if (timer.current != null) {
    clearTimeout(timer.current)
    // eslint-disable-next-line no-param-reassign
    timer.current = null
  }
  return timer.current
}

export default {}
